export default __webpack_public_path__ + "img/since.a65e59dc.png";